import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaFilePdf, FaSpinner } from 'react-icons/fa';
import { pdf } from '@react-pdf/renderer';
import QuotePDF from './QuotePDF';
import { getCompanyDetails } from '../config/CompanyDetails';

function QuotePDFButton({ quote, onGenerate, buttonText = 'Generate PDF', className = '' }) {
  const [isGenerating, setIsGenerating] = useState(false);

  if (!quote || !quote.quote_number) {
    return (
      <button
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium opacity-50 cursor-not-allowed ${className}`}
        style={{
          backgroundColor: '#94A3B8',
          color: 'white',
          border: 'none',
        }}
        disabled
      >
        <FaFilePdf size={12} /> No Quote Data
      </button>
    );
  }

  // ✅ SINGLE GENERATION - Only runs once when button is clicked
  const handleGenerate = async () => {
    if (isGenerating) return; // Prevent double clicks
    
    setIsGenerating(true);
    if (onGenerate) onGenerate();
    toast.info('📄 Generating PDF...');

    try {
      console.log('📄 Generating PDF for:', quote.quote_number);
      
      // ✅ Company details ALWAYS from the single source
      const company = await getCompanyDetails();

      // ✅ Generate the PDF as a blob
      const blob = await pdf(<QuotePDF quote={quote} companyDetails={company} />).toBlob();
      
      // ✅ Create a download link and trigger it
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${quote.quote_number || 'Quote'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // ✅ Clean up the URL
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      
      toast.success('✅ PDF downloaded successfully!');
      console.log('✅ PDF downloaded:', quote.quote_number);
    } catch (error) {
      console.error('❌ PDF Generation Error:', error);
      toast.error('Failed to generate PDF. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button
      onClick={handleGenerate}
      disabled={isGenerating}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors shadow-sm ${className}`}
      style={{
        backgroundColor: isGenerating ? '#94A3B8' : '#00A86B',
        color: 'white',
        border: 'none',
        cursor: isGenerating ? 'default' : 'pointer'
      }}
      onMouseEnter={(e) => {
        if (!isGenerating) e.currentTarget.style.backgroundColor = '#00995E';
      }}
      onMouseLeave={(e) => {
        if (!isGenerating) e.currentTarget.style.backgroundColor = '#00A86B';
      }}
    >
      {isGenerating ? (
        <>
          <FaSpinner className="animate-spin" size={12} />
          Generating...
        </>
      ) : (
        <>
          <FaFilePdf size={12} />
          {buttonText}
        </>
      )}
    </button>
  );
}

export default QuotePDFButton;